(() => {
  const form = document.querySelector('#ac-private-feedback');
  const phone = form && form.querySelector('[data-feedback-phone]');
  const library = window.libphonenumber;
  if (!phone || !library) return;

  const country = phone.querySelector('[data-phone-country]');
  const number = phone.querySelector('[data-phone-number]');
  const prefix = phone.querySelector('[data-phone-prefix]');
  const value = phone.querySelector('[data-phone-value]');
  const hint = phone.querySelector('[data-phone-hint]');
  const email = form.querySelector('#ac-review-email');
  const deliveryEmail = form.querySelector('[data-feedback-delivery-email]');
  const preferredReply = form.querySelector('[data-feedback-preferred-reply]');
  if (!country || !number || !prefix || !value || !hint) return;

  const quickCountries = ['AU', 'BR', 'FR', 'NL', 'DE', 'NO', 'RU'];
  const countries = library.getCountries();
  const callingCodes = new Map();
  countries.forEach((code) => {
    const callingCode = library.getCountryCallingCode(code);
    if (!callingCodes.has(callingCode)) callingCodes.set(callingCode, []);
    callingCodes.get(callingCode).push(code);
  });
  const sortedCallingCodes = [...callingCodes.keys()].sort((a, b) => b.length - a.length);
  const sharedCodeDefaults = { 1: 'US', 7: 'RU', 39: 'IT', 44: 'GB', 61: 'AU', 590: 'GP', 599: 'CW' };
  const placeholders = {
    AU: '0412 345 678', BR: '(11) 98765-4321', FR: '06 12 34 56 78',
    NL: '06 12345678', DE: '01512 3456789', NO: '412 34 567',
    RU: '8 (912) 345-67-89', US: '(202) 555-0123', CA: '(416) 555-0123',
    GB: '07700 900123', JP: '090-1234-5678'
  };
  const words = {
    en: {
      country: 'Phone country and calling code', quick: 'Quick picks', all: 'Other countries',
      placeholder: 'Phone number', invalid: 'Enter a complete phone number for', required: 'Enter your phone number.'
    },
    pt: {
      country: 'País e código de telefone', quick: 'Acesso rápido', all: 'Outros países',
      placeholder: 'Número de telefone', invalid: 'Digite um telefone completo para', required: 'Digite seu telefone.'
    }
  };
  let language = document.documentElement.lang.startsWith('en') ? 'en' : 'pt';
  let displayError = false;
  let displayNames;
  const digits = (text) => text.replace(/\D/g, '');
  const flag = (code) => String.fromCodePoint(...[...code].map((letter) => 127397 + letter.charCodeAt(0)));
  const countryName = (code) => displayNames ? displayNames.of(code) : code;

  function updateCountryDetails() {
    prefix.textContent = '+' + library.getCountryCallingCode(country.value);
    number.placeholder = placeholders[country.value] || words[language].placeholder;
  }

  function syncContactDetails(possiblePhone) {
    if (!email) return;
    const guestEmail = email.value.trim();
    const fallbackEmail = deliveryEmail ? (deliveryEmail.dataset.fallbackEmail || '').trim() : '';
    const phoneOnlyAllowed = Boolean(possiblePhone && fallbackEmail);
    email.required = !phoneOnlyAllowed;
    if (deliveryEmail) deliveryEmail.value = guestEmail || (phoneOnlyAllowed ? fallbackEmail : '');
    if (preferredReply) preferredReply.value = !guestEmail && phoneOnlyAllowed
      ? 'Phone — customer supplied no email; store address used for form delivery only.'
      : 'Email';
  }

  function updateValidity(showError = false) {
    if (showError) displayError = true;
    const hasNumber = number.value.trim().length > 0;
    let parsed;
    try {
      parsed = hasNumber ? library.parsePhoneNumberFromString(number.value, country.value) : null;
    } catch (_) {
      parsed = null;
    }
    const possible = Boolean(parsed && parsed.isPossible());
    const message = hasNumber && !possible
      ? words[language].invalid + ' ' + countryName(country.value) + '.'
      : (!hasNumber && number.required ? words[language].required : '');
    value.value = possible ? parsed.number : '';
    syncContactDetails(possible);
    number.setCustomValidity(message);
    if (!message) displayError = false;
    number.setAttribute('aria-invalid', displayError && message ? 'true' : 'false');
    hint.classList.toggle('is-error', Boolean(displayError && message));
    hint.hidden = !displayError || !message;
    hint.textContent = displayError && message ? message : '';
    return !message;
  }

  function caretAfterDigits(text, count) {
    if (!count) return 0;
    if (count >= digits(text).length) return text.length;
    let found = 0;
    for (let index = 0; index < text.length; index++) {
      if (/\d/.test(text[index]) && ++found === count) return index + 1;
    }
    return text.length;
  }

  function internationalParts(raw) {
    if (!/^\s*(?:\+|00)/.test(raw)) return null;
    const internationalDigits = digits(raw.replace(/^\s*(?:\+|00)/, ''));
    const callingCode = sortedCallingCodes.find((code) => internationalDigits.startsWith(code));
    if (!callingCode) return { incomplete: true };
    let parsed;
    try {
      parsed = library.parsePhoneNumberFromString('+' + internationalDigits);
    } catch (_) {
      parsed = null;
    }
    const candidates = callingCodes.get(callingCode);
    const selected = candidates.includes(country.value) ? country.value : null;
    const inferred = parsed && parsed.country;
    return {
      country: inferred || selected || sharedCodeDefaults[callingCode] || candidates[0],
      national: internationalDigits.slice(callingCode.length),
      removedDigits: callingCode.length + (/^\s*00/.test(raw) ? 2 : 0)
    };
  }

  function formatNumber(preserveCaret = false, interpretInternational = true) {
    const raw = number.value;
    const cursor = number.selectionStart === null ? raw.length : number.selectionStart;
    let caretDigits = digits(raw.slice(0, cursor)).length;
    let national = digits(raw);
    const international = interpretInternational ? internationalParts(raw) : null;
    if (international && international.incomplete) {
      // Keep a partially typed +/00 code until it identifies a country.
      updateValidity();
      return;
    }
    if (international) {
      country.value = international.country;
      national = international.national;
      caretDigits = Math.max(0, caretDigits - international.removedDigits);
    }
    let formatted = new library.AsYouType(country.value).input(national);
    if (national && formatted === national) {
      // An international paste omits domestic trunk prefixes such as France's 0.
      // Format those significant digits internationally, keeping the country code outside the input.
      const countryPrefix = '+' + library.getCountryCallingCode(country.value);
      const internationalFormat = new library.AsYouType().input(countryPrefix + national);
      if (internationalFormat.startsWith(countryPrefix)) {
        formatted = internationalFormat.slice(countryPrefix.length).trimStart();
      }
    }
    number.value = formatted;
    updateCountryDetails();
    updateValidity();
    if (preserveCaret && document.activeElement === number) {
      const position = caretAfterDigits(number.value, caretDigits);
      number.setSelectionRange(position, position);
    }
  }

  function localize(nextLanguage) {
    language = nextLanguage === 'en' ? 'en' : 'pt';
    const selected = countries.includes(country.value) ? country.value : 'BR';
    try {
      displayNames = new Intl.DisplayNames([language === 'pt' ? 'pt-BR' : 'en'], { type: 'region' });
    } catch (_) {
      displayNames = null;
    }
    const optionGroup = (label, codes) => {
      const group = document.createElement('optgroup');
      group.label = label;
      codes.forEach((code) => {
        const option = document.createElement('option');
        option.value = code;
        option.defaultSelected = code === 'BR';
        option.textContent = flag(code) + ' ' + countryName(code) + ' (+' + library.getCountryCallingCode(code) + ')';
        group.append(option);
      });
      return group;
    };
    const collator = new Intl.Collator(language);
    const others = countries.filter((code) => !quickCountries.includes(code))
      .sort((a, b) => collator.compare(countryName(a), countryName(b)));
    country.replaceChildren(optionGroup(words[language].quick, quickCountries), optionGroup(words[language].all, others));
    country.value = selected;
    country.setAttribute('aria-label', words[language].country);
    updateCountryDetails();
    updateValidity();
  }

  number.addEventListener('input', () => formatNumber(true));
  number.addEventListener('beforeinput', (event) => {
    if (event.inputType !== 'deleteContentBackward' && event.inputType !== 'deleteContentForward') return;
    const start = number.selectionStart;
    if (start === null || start !== number.selectionEnd) return;
    const backwards = event.inputType === 'deleteContentBackward';
    const adjacent = backwards ? start - 1 : start;
    if (adjacent < 0 || adjacent >= number.value.length || /\d/.test(number.value[adjacent])) return;
    let target = adjacent;
    while (target >= 0 && target < number.value.length && !/\d/.test(number.value[target])) target += backwards ? -1 : 1;
    if (target < 0 || target >= number.value.length) return;
    // Deleting beside an inserted space/bracket must remove a digit, not restore the separator forever.
    event.preventDefault();
    number.value = number.value.slice(0, target) + number.value.slice(target + 1);
    const cursor = backwards ? target : start;
    number.setSelectionRange(cursor, cursor);
    formatNumber(true);
  });
  number.addEventListener('blur', () => updateValidity(true));
  number.addEventListener('invalid', () => updateValidity(true));
  if (email) {
    email.addEventListener('input', () => updateValidity());
    email.addEventListener('change', () => updateValidity());
  }
  country.addEventListener('change', () => {
    const international = internationalParts(number.value);
    if (international) number.value = international.incomplete ? '' : international.national;
    updateCountryDetails();
    formatNumber(false, false);
  });
  form.addEventListener('submit', (event) => {
    formatNumber();
    if (!updateValidity(true)) {
      event.preventDefault();
      number.reportValidity();
    } else if (email && !email.checkValidity()) {
      event.preventDefault();
      email.reportValidity();
    }
  });
  const reset = () => {
    country.value = 'BR';
    number.value = '';
    displayError = false;
    updateCountryDetails();
    updateValidity();
  };
  form.addEventListener('reset', () => window.setTimeout(reset, 0));
  window.AussieFeedbackPhone = {
    localize,
    validate: () => updateValidity(true),
    reset
  };
  localize(language);
  formatNumber();
})();
